<template>
<div class="chapter">
<div class="inner_page">
<p class="p1">To Mate, Mary, and all assorted Spawn. And to Marie, RJ, and Amber, ’cause lobby-con can do strange things to women,<br/>
   and this was one of the best.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?86828d38